export const neonGlowClass = "neon-glow"
export const neonFillClass = "neon-fill"
export const neonHeadingClass = `font-bold font-mono uppercase ${neonFillClass} ${neonGlowClass}`
